<div id="main">
    <div class="content">
      <a><img src="../../../assets/img/FreeMove_2023_Logo-website_slogan.png" class="logo-home">
      </a>
    </div>
  </div>